var exports = {
  "Z": "xe564cbfb--8c5cc4--layout",
  "D": "xe564cbfb--8c5cc4--click-area",
};

module.exports = exports;
